export default __webpack_public_path__ + "static/media/autofact-logo.4b9ee433.svg";